import { dialogDraftsAdapter } from "./slice"
import { RootState } from "../rootReducer"

export const {
    selectAll: selectAllDrafts,
    selectById: selectDraftById,
    selectIds: selectDraftIds
} = dialogDraftsAdapter.getSelectors<RootState>(state => state.dialogDrafts)
